import { useEffect, useRef } from 'react';

export const useTabScrolling = (
  activeCard: number,
  tabButtonRefs: React.MutableRefObject<(HTMLButtonElement | null)[]>,
  tabsContainerRef: React.MutableRefObject<HTMLDivElement | null>,
  anchorRefs: React.MutableRefObject<(HTMLAnchorElement | null)[]>
) => {
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Skip the initial render to prevent auto-scrolling on page load
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      return;
    }

    const anchorElement = anchorRefs.current[activeCard];
    anchorElement?.scrollIntoView({ behavior: 'smooth' });
    
    // Scroll the active tab button into view horizontally within the tabs container
    const activeButton = tabButtonRefs.current[activeCard];
    const tabsContainer = tabsContainerRef.current;
    
    if (activeButton && tabsContainer) {
      const buttonLeft = activeButton.offsetLeft;
      const buttonWidth = activeButton.offsetWidth;
      const containerWidth = tabsContainer.offsetWidth;
      const scrollLeft = buttonLeft - (containerWidth / 2) + (buttonWidth / 2);
      
      tabsContainer.scrollLeft = Math.max(0, scrollLeft);
    }
  }, [activeCard, tabButtonRefs, tabsContainerRef, anchorRefs]);
};
